<template>
  <div class="product-proposal">
    <p>Cherchez vous un des produits ci-dessous ?</p>
    <ul>
      <li v-for="item in products" v-bind:key="item.id" @click="choose(item.id)">{{item.name_internet}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["products"],
  methods: {
    choose: function(id) {
      this.$router.push({ name: "product-view", params: { id: id } });
    }
  }
};
</script>

<style scoped>
p {
  font-weight: bold;
}
li {
  border: 2px solid black;
  margin-top: 10px;
  list-style-type: none;
  margin-bottom: 10px;
  padding: 4px;
}
</style>
